// @flow

import classNames from 'classnames';
import React from 'react';
import type { Node } from 'react';
import { MediaQuery } from '@riseart/common';
import { Wrapper } from '@riseart/layout';
import { ContentAttribute } from 'shared_components/cms/attributes/Content';
import { generateSrcForCDN } from 'shared_components/common/artdirection/picture/Picture';

import {
  raScreenXsMax,
  raScreenSm,
  raScreenMdMax,
  raScreenLg,
} from '@riseart/antd-provider/dist/website/variables.less';
import {
  parallaxCls,
  parallaxContentCls,
  parallaxWhiteCls,
  parallaxBlackCls,
  parallaxMainCls,
  parallaxCaptionCls,
  parallaxLeftCls,
  parallaxCenterCls,
  parallaxRightCls,
} from 'shared_components/common/banner/Parallax.less';

type Props = {
  align?: 'left' | 'center' | 'right',
  media: Object,
  caption?: string | Node,
  content?: ?Object,
};

/**
 * ParallaxBanner
 *
 * @param {Props} props
 * @returns {Node}
 */
export function ParallaxBanner({ align, caption, content, media }: Props): Node {
  const FONT_COLOR = { WHITE: 'white', BLACK: 'black' };
  const FONT_COLOR_CLASSNAME = {
    [FONT_COLOR.WHITE]: parallaxWhiteCls,
    [FONT_COLOR.BLACK]: parallaxBlackCls,
  };
  const ALIGN_CLASSNAME = {
    left: parallaxLeftCls,
    center: parallaxCenterCls,
    right: parallaxRightCls,
  };

  return (
    <MediaQuery maxWidth={raScreenXsMax}>
      {(isPhone) => (
        <MediaQuery minWidth={raScreenSm} maxWidth={raScreenMdMax}>
          {(isTablet) => (
            <MediaQuery minWidth={raScreenLg}>
              {(isDesktop) => {
                const { font = FONT_COLOR.WHITE, file } =
                  (isPhone && media && media.small) ||
                  (isTablet && media && media.medium) ||
                  (isDesktop && media && media.large) ||
                  {};
                const backgroundImage = file ? generateSrcForCDN(file) : null;

                return (
                  <div
                    className={classNames(
                      parallaxCls,
                      FONT_COLOR_CLASSNAME[font],
                      align && ALIGN_CLASSNAME[align],
                    )}
                    style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : null}
                  >
                    <Wrapper>
                      <div className={parallaxContentCls}>
                        {content ? (
                          <div className={parallaxMainCls}>
                            <ContentAttribute {...content} />
                          </div>
                        ) : null}
                        {caption ? <div className={parallaxCaptionCls}>{caption}</div> : null}
                      </div>
                    </Wrapper>
                  </div>
                );
              }}
            </MediaQuery>
          )}
        </MediaQuery>
      )}
    </MediaQuery>
  );
}
